import { Response } from '@angular/http';
import { JhiDateUtils } from 'ng-jhipster';
import { BaseEntity, ResponseWrapper } from '../../models';

export class Converter {

    public static fromJson<T extends BaseEntity>(type: { new(): T; }, model: T, dateUtils?: JhiDateUtils): T {
        const copy: T = Object.assign(new type(), model);
        if (copy.convertFromServerTypes && dateUtils != null) {
            copy.convertFromServerTypes(dateUtils);
        }
        return copy;
    }

    public static fromJsonArray<T extends BaseEntity>(type: { new(): T; }, models: T[], dateUtils?: JhiDateUtils): Array<T> {
        const array: Array<T> = [];
        models.forEach((model: T) => {
            array.push(Converter.fromJson(type, model, dateUtils));
        });
        return array;
    }

    public static toJson<T extends BaseEntity>(model: T, dateUtils?: JhiDateUtils): T {
        if (model.convertToSimpleTypes && dateUtils != null) {
            model.convertToSimpleTypes(dateUtils);
        }
        const copy: T = Object.assign({}, model);
        return copy;
    }

    public static toResponseWrapper<T extends BaseEntity>(model: T, response: Response) {
        return new ResponseWrapper(response.headers, model, response.status);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/utils/converter.ts